import { AfterViewInit, Component, HostListener, OnInit, Renderer2, NgZone } from '@angular/core';
import { CommonService } from './services/Common-function/common.service';
import { MessageService } from 'primeng/api';
import { BrowserStorageService } from './services/browser-storage/browser-storage.service';
import { AuthService } from './services/Auth/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { UserDetails } from './models/user-details.model';
import { GuestCartService } from './services/cart/guest-cart.service';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs';
import { pairwise } from 'rxjs/operators';
import { SaleTimerService } from './services/SaleTimerService/sale-timer.service';
import { PlatformSaleService } from './services/platform-sale/platform-sale.service';
import { InAppBrowserService } from './services/in-app-browser.service';
declare var google:any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit, AfterViewInit {
  private ctLoaded: boolean = false;
  title = 'IPM-frontend1-v3';
  currentOrigin = "https://illpeoplemusic.com";
  constructor(private renderer: Renderer2,
    public commonFunction :  CommonService,
    public messageService : MessageService,
    public browserService: BrowserStorageService,
    public ngZone: NgZone,
    private authService: AuthService,
    private router: Router,
    private saleTimer: SaleTimerService,
    private platformSaleService: PlatformSaleService,
    private inAppBrowserService: InAppBrowserService,
    private guestCartService: GuestCartService) {
      this.currentOrigin = window.origin;
      // if (this.commonFunction.isNewBeatLogoEnable) {
      //   this.router.navigate(['/coming-soon']);
      // }
  }
  @HostListener('window:resize', ['$event'])
	onResize(event:any) {
    this.commonFunction.upDateOnWindowResize(event);
  }
   ngOnInit() {
    this.inAppBrowserService.checkAndHandleInAppBrowser();

    // aos.init();
    // aos.init({ disable: 'tablet' });
    this.authService.currentUserDetails.subscribe((userDetails: UserDetails) => {
      if (userDetails && !this.ctLoaded) {
              this.injectCleverTapSnippet();
              this.ctLoaded = true;
      } });
    this.authService.closeAllDialogBox.subscribe((res) => {
      if (res) {
        this.commonFunction.closePopUp()
      }
    });
    (window as any).angularComponentRef = {
      navigateTo: this.navigateTo.bind(this)
    };
      this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        pairwise()
      )
      .subscribe((events: any[]) => {
        // Cast to NavigationEnd after filtering
        const prevEvent = events[0] as NavigationEnd;
        const currEvent = events[1] as NavigationEnd;
        
        const previousUrl = prevEvent.urlAfterRedirects;
        const currentUrl = currEvent.urlAfterRedirects;
        if (!this.browserService.getSessionData()) {
          this.browserService.setPreviousRoute(previousUrl);
        }
      });

    this.saleTimer.saleStatus$.subscribe(status => {
      // sale start / end (the countdown reaches 0): refresh the sale data in place, no page reload, no loader;
      // the layout plays the Diwali sale intro when the sale goes live
      if (status === 'live') {
        if (this.browserService.getCurrentSaleStatus() !== "live") {
          this.browserService.setCurrentSaleStatus(status);
          this.refreshSaleData();
        }
      } else if (status === 'ended') {
        if (this.browserService.getCurrentSaleStatus() !== "ended") {
          this.browserService.setCurrentSaleStatus(status);
          this.refreshSaleData();
        }
      } else if (this.browserService.getCurrentSaleStatus() !== "upcoming") {
        // remember "upcoming" so the next start is always seen as a change
        this.browserService.setCurrentSaleStatus(status);
      }
    });
  }
  private injectCleverTapSnippet() {
  const w = window as any;

  // Prepare stub queues so calls do not break
  w.clevertap = w.clevertap || {
    event: [], profile: [], account: [], onUserLogin: [], notifications: [], privacy: []
  };
  // Set your account details
  w.clevertap.account.push({ id: environment.calverTapId });
  w.clevertap.privacy.push({ optOut: false });
  w.clevertap.privacy.push({ useIP: false });

  // Load the SDK
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.src = (document.location.protocol === 'https:'
    ? 'https://d2r1yp2w7bby2u.cloudfront.net/js/clevertap.min.js'
    : 'http://static.clevertap.com/js/clevertap.min.js');
  s.onload = () => {
    // Initialise the SDK
    w.clevertap.init({ accountId: environment.calverTapId, region: 'in1' });
    w.clevertap.setLogLevel(0);

    // Flush any queued events from localStorage
    try {
      const queued = JSON.parse(localStorage.getItem('ctQueuedEvents') || '[]');
      queued.forEach((ev: any) => {
        w.clevertap.event.push(ev.eventName, ev.eventParams);
      });
      localStorage.removeItem('ctQueuedEvents');
    } catch (e) {
      console.error('Failed to flush queued events', e);
    }
  };

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode!.insertBefore(s, firstScript);
}
  ngAfterViewInit() {
  }

  navigateTo(route: string) {
    if (route === "OpenSubsModel") {
      this.commonFunction.openSubsModel.next("open");
    } else {
      this.router.navigate([route]);
    }
  }
  /**
   * Re-fetch the active platform sale (no loader) and push it to every sale-aware part of the site
   * (navbar, strips, hero panel, beat lists, prices...) through CommonService.saleDataUpdate
   */
  refreshSaleData() {
    this.platformSaleService.getActivePlatFormSale(false).subscribe({
      next: (response: any) => this.commonFunction.saleDataUpdate(response?.data?.sales || []),
      error: () => {
        // keep the current sale data; the sale state still follows its dates
      },
    });
  }
}
